import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pdl-10 pdr-10 mt-30" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-20" }, "Productions (Reports)", -1)
const _hoisted_3 = { class: "d-flex flex-column gap-4 mt-20" }
const _hoisted_4 = { class: "d-flex flex-column gap-20" }
const _hoisted_5 = { class: "d-flex align-items-end gap-20 w-100" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center gap-20 w-100 mt-10" }
const _hoisted_7 = { class: "d-flex justify-content-between gap-20" }
const _hoisted_8 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_9 = {
  class: "small striped toggle no-underline mt-30",
  id: "table-productions"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", { class: "large large_padding" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-center align-middle" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Productions/Venue"),
    /*#__PURE__*/_createElementVNode("th", null, "Payor")
  ])
], -1)
const _hoisted_11 = { class: "large" }
const _hoisted_12 = { class: "col-md-1" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 0,
  class: "hidden"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "7",
  style: {"background-color":"white","height":"130px"}
}, null, -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_DateInput = _resolveComponent("DateInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, {
      error: $setup.errors?.General
    }, null, 8, ["error"]),
    _createElementVNode("form", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_MessageCard, {
        message: "This page allows you to view a list of Productions that are on file at the Fund Office based on the work period you input.",
        type: "primary",
        iconClass: "iatse-icon-alarm",
        classes: "info_card__page"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_DateInput, {
              label: "Work Period Start",
              modelValue: $setup.filters.StartDate,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.filters.StartDate) = $event)),
              reset: $setup.reset,
              "onUpdate:reset": _cache[1] || (_cache[1] = ($event: any) => (($setup.reset) = $event)),
              isRequired: true,
              error: $setup.errors.StartDate,
              "error-placement": "top"
            }, null, 8, ["modelValue", "reset", "error"]),
            _createVNode(_component_DateInput, {
              label: "Work Period End",
              modelValue: $setup.filters.EndDate,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters.EndDate) = $event)),
              reset: $setup.reset,
              "onUpdate:reset": _cache[3] || (_cache[3] = ($event: any) => (($setup.reset) = $event)),
              isRequired: true,
              error: $setup.errors.EndDate,
              "error-placement": "top"
            }, null, 8, ["modelValue", "reset", "error"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => ($setup.resetFilters && $setup.resetFilters(...args)), ["prevent"]))
          }, "Clear Filters"),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.searchData && $setup.searchData(...args)), ["prevent"])),
            onKeydown: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchData && $setup.searchData(...args)), ["enter"]))
          }, _toDisplayString($setup.loading ? 'Searching...' : 'Search'), 33)
        ]),
        ($setup.productions.length)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: "iatse-icon-printer fs-xxl text-primary plan-modal sm-fs-xl",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.printList && $setup.printList(...args)))
            }))
          : _createCommentVNode("", true)
      ]),
      (!$setup.loading && $setup.productions.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productions, (production, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: production.ProductionName
                  }, [
                    _createElementVNode("tr", _hoisted_11, [
                      _createElementVNode("td", _hoisted_12, _toDisplayString(production.ProductionName), 1),
                      _createElementVNode("td", {
                        class: "col-md-1",
                        innerHTML: production.Payor
                      }, null, 8, _hoisted_13)
                    ]),
                    ((index + 1) % 28 === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_14, _hoisted_16))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}